import cn from "classnames"
import { ReactNode } from "react"

interface Props {
    children: ReactNode
    className?: string
    autoGrid?: boolean
    isFloating?: boolean
    isFullScreen?: boolean
    isRoundCorners?: boolean
    isWithBanner?: boolean
}

export function RoomPageFrame(props: Props) {
    return (
        <div
            className={cn(
                "is-flex-grow-1 room-call-page__video-frame",
                {
                    "room-call-page__auto-grid": props.autoGrid,
                    "room-call-page__floating": props.isFloating,
                    "room-call-page__fullscreen": props.isFullScreen,
                    "room-call-page__round-corners": props.isRoundCorners,
                    "room-call-page__floating-with-banner": props.isWithBanner,
                },
                props.className
            )}
        >
            {props.children}
        </div>
    )
}
